import { ANSWER_MESSAGE } from 'orden_express/frameWork/frameWork';
import { ofType } from 'redux-observable';
import { URL_SERVER } from 'routes';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs/index';
import { catchError, map, mergeMap } from 'rxjs/operators';


const REQUEST_VERIFIED_USER = 'REQUEST_VERIFIED_USER';
export const requestVerifiedUser = (requestVerifiedUser) => (
  {
    type: REQUEST_VERIFIED_USER,
    requestVerifiedUser
  }
);
export const RESPONSE_VERIFIED_USER = 'RESPONSE_VERIFIED_USER';
const responseVerifiedUser = responseVerifiedUser => (
  {
    type: RESPONSE_VERIFIED_USER,
    responseVerifiedUser
  }
);
export const fromServerVerifiedUser = action$ => action$.pipe(
  ofType(REQUEST_VERIFIED_USER),
  mergeMap(action =>
    ajax.post(URL_SERVER + '/user/validate', action.requestVerifiedUser, { 'Content-Type': 'application/json' }).pipe(
      map(response => responseVerifiedUser(response.response)),
      catchError(error => of(responseVerifiedUser(ANSWER_MESSAGE(true, 'Hubo problemas de conexión, intentelo nuevamente', error))))
    )
  )
);

export const REQUEST_MENU_PERMISSIONS = 'REQUEST_MENU_PERMISSIONS';
export const requestMenuPermissions = (requestMenuPermissions) => (
  {
    type: REQUEST_MENU_PERMISSIONS,
    requestMenuPermissions
  }
);

export const REQUEST_RESET_STATE_LOGIN = 'REQUEST_RESET_STATE_LOGIN';
export const requestResetStateLogin = () => (
  {
    type: REQUEST_RESET_STATE_LOGIN
  }
);

export default this;


